module.exports = __webpack_public_path__ + "img/money-inactive-4.16b5ee60.png";